import { chartsAdapter, ChartsState } from './chart.reducer';
import { createFeatureSelector, createSelector, select } from '@ngrx/store';
import { isMapDashboardElement, isTableDashboardElement } from '../../../models/chart.models';
import { filter } from 'rxjs/operators';
import { pipe } from 'rxjs';
import { getPageById, getPagesEntities } from '../page/page.selectors';

export const getChartsState = createFeatureSelector<ChartsState>('charts');

const { selectAll, selectEntities } = chartsAdapter.getSelectors();

export const getAllCharts = createSelector(getChartsState, selectAll);

export const getAllChartsFiltered = pipe(
  select(getAllCharts),
  filter(charts => !!charts)
);
export const getChartsEntities = createSelector(getChartsState, selectEntities);

export const getChartsByBaselineId = (baselineId: string) =>
  createSelector(getAllCharts, charts => charts.filter(ch => ch.baselineId === baselineId));

export const getChartByBaselineIdWithParentId = (baselineId: string, parentId: string) =>
  createSelector(getChartsByBaselineId(baselineId), charts => charts.find(ch => ch.parentChartId === parentId));

export const getChartById = (id: string) => createSelector(getChartsEntities, chartEntities => chartEntities[id]);

export const getChartByBaselineId = (id: string) =>
  createSelector(getChartsEntities, chartEntities =>
    Object.values(chartEntities).find(chart => chart.baselineId === id)
  );

export const getChartsProcessing = createSelector(getChartsState, state => state.processing);

export const getChartsloading = createSelector(getChartsState, state => state.loading);

export const getChartsStatus = createSelector(
  getChartsState,
  state => <ChartsState>{ loading: state.loading, loadError: state.loadError, loaded: state.loaded }
);

export const getChartInfoPanelConfig = (chartId: string) =>
  createSelector(getChartsEntities, charts => {
    const chart = charts[chartId];
    if (isMapDashboardElement(chart)) {
      return chart.mapInfoPanel;
    }
  });

export const getSignalStrengthNetworkCarriers = (chartId: string) =>
  createSelector(getChartsEntities, charts => {
    const chart = charts[chartId];
    if (isMapDashboardElement(chart)) {
      if (chart.filters && chart.filters.carriers) {
        return chart.filters.carriers;
      }
    }
  });

export const getTableFilter = (chartId: string) =>
  createSelector(getChartsEntities, charts => {
    const chart = charts[chartId];
    if (isTableDashboardElement(chart)) {
      return chart.filters;
    }
  });

export const getMapUIParams = (chartId: string) =>
  createSelector(getChartsEntities, charts => {
    const chart = charts[chartId];
    if (isMapDashboardElement(chart)) {
      return chart.uiParams;
    }
  });

export const getTableFiltersForPage = (pageId: string) =>
  createSelector(getPageById(pageId), getChartsEntities, (page, charts) => {
    return page.chartIds
      .filter(chartId => isTableDashboardElement(charts[chartId]))
      .map(chartId => {
        return { chartId: chartId, filters: charts[chartId].filters };
      });
  });
